import { render, staticRenderFns } from "./SellersGuideToSuccess.vue?vue&type=template&id=b28f7b4c&scoped=true&"
import script from "./SellersGuideToSuccess.vue?vue&type=script&lang=ts&"
export * from "./SellersGuideToSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f7b4c",
  null
  
)

export default component.exports